import type {ReactNode} from 'react'
import {useOverviewRouteData} from './data/use-overview-route-data'
import {SidebarSection} from './SidebarSection'
import {AssigneesPicker} from './AssigneesPicker'

/**
 * Assignees sidebar section. Renders the read-only assignee list (`children`)
 * and, when the viewer can assign, a gear-triggered "Manage assignees" header
 * that anchors the shared assignee picker.
 */
export function AssigneesSection({children}: {children: ReactNode}) {
  const {user} = useOverviewRouteData()
  const canAssign = user?.canAssign ?? false

  return (
    <SidebarSection title="Assignees" header={canAssign ? <AssigneesPicker /> : undefined}>
      {children}
    </SidebarSection>
  )
}
